import script from "./BannerTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./BannerTemplate.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__